import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isProductsReadyOrError, getProductsWithVisibility } from '../../selectors';
import Product, { productPropTypes } from '../Product';
import Cards from '../ContentTray/Cards';
import { colourThemeType } from '../../propTypes';
import { sliceColourTheme } from '../../styles/theme';

const Products = ({
  className, products, ready, sliceId, colourTheme,
}) => (
  <Cards
    className={className}
    Card={Product}
    cards={products}
    ready={ready}
    sliceId={sliceId}
    colourTheme={colourTheme}
  />
);

Products.propTypes = {
  className: PropTypes.string,
  products: PropTypes.arrayOf(PropTypes.shape(productPropTypes)).isRequired,
  ready: PropTypes.bool.isRequired,
  sliceId: PropTypes.number.isRequired,
  colourTheme: colourThemeType,
};

Products.defaultProps = {
  className: undefined,
  colourTheme: sliceColourTheme.white,
};

const mapStateToProps = (state, { sliceId }) => ({
  products: getProductsWithVisibility(state, sliceId),
  ready: isProductsReadyOrError(state, sliceId),
});

export default connect(mapStateToProps)(Products);
